var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { transient, autoinject } from 'aurelia-dependency-injection';
import { BaseLobby } from '../../base-lobby';
import { BrandingBase } from '../../../../../views/app/admin/branding/branding-base';
import { Router } from 'aurelia-router';
import { TokenClient } from '../../../../../services/authentication/token-client.service';
import { I18N } from 'aurelia-i18n';
import { ClientLotteryClientService } from '../../../../../services/modules/client/client-lottery-client-service';
import { NotificationClientService } from '../../../../../services/basics/notification-client.service';
import { DialogClientService } from '../../../../../services/basics/dialog-client.service';
import { QuickPlay } from '../common/quick-play/quick-play';
import { ConfigClientService } from '../../../../../services/modules/client-config.service';
import { RoutingHelper } from '../../../../../helpers/routing.helper';
import { BindingSignaler } from 'aurelia-templating-resources';
var Lobby = /** @class */ (function (_super) {
    __extends(Lobby, _super);
    function Lobby(lotteryClientService, router, tokenClient, i18n, notificationClientService, dialogClientService, quickPlay, configClientService, routingHelper, bindingSignaler) {
        var _this = _super.call(this, lotteryClientService, router, tokenClient, i18n, notificationClientService, dialogClientService, configClientService, routingHelper, bindingSignaler) || this;
        _this.animating = false;
        return _this;
    }
    Lobby.prototype.termsAndConditions = function () {
        window.parent.postMessage({
            key: BrandingBase.SelectBrandingKey,
            value: [
                //Images
                //Text
                //Colors
                "terms-and-conditions-foreground"
            ]
        }, window.parent.location.origin);
    };
    Lobby.prototype.showFold = function () {
        window.parent.postMessage({
            key: BrandingBase.SelectBrandingKey,
            value: [
                // Images
                "template-background-xs",
                "template-background-sm",
                "template-background-lg",
                // Text
                "navigation-nav-home",
                "navigation-nav-latest-results",
                "navigation-nav-my-purchases",
                "navigation-nav-agent-winning-claims",
                "navigation-nav-cart",
                "navigation-nav-lotteries",
                "navigation-nav-bundles",
                "fold-subscribe",
                "fold-button-subscribe",
                "fold-button-play",
                "fold-next-draw",
                // Colors
                "template-background",
                "header-background",
                "header-navigation-nav-foreground",
                "header-navigation-nav-foreground-hover",
                "header-navigation-nav-background",
                "header-navigation-nav-background-hover",
                "header-navigation-nav-divider",
                "header-navigation-nav-selected-background",
                "header-navigation-nav-selected-foreground",
                "header-navigation-fab-cart-foreground",
                "header-navigation-fab-cart-background",
                "header-cart-count-background",
                "header-cart-count-foreground",
                "header-purchase-count-background",
                "header-purchase-count-foreground",
                "fold-background",
                "fold-button-subscribe-background",
                "fold-button-subscribe-background-hover",
                "fold-button-subscribe-foreground",
                "fold-button-subscribe-foreground-hover",
                "fold-jackpot-background",
                "fold-jackpot-title-foreground",
                "fold-jackpot-prize-foreground",
                "fold-jackpot-time-remaining-foreground",
                "fold-jackpot-time-remaining-border",
                "fold-jackpot-button-background",
                "fold-jackpot-button-hover-background",
                "fold-jackpot-button-foreground",
                "fold-jackpot-button-hover-foreground",
                "fold-jackpot-subscribe-foreground",
                "terms-and-conditions-foreground",
                //featured
                "featured-top-banner-lottery",
                "featured-top-banner-jackpot-background",
                "featured-subscribe-lottery"
            ]
        }, window.parent.location.origin);
    };
    Lobby.prototype.showStories = function () {
        window.parent.postMessage({
            key: BrandingBase.SelectBrandingKey,
            value: [
                //Images
                //Text
                "lotteries-stories-closing-text",
                //Colors
                "lotteries-stories-jackpot-foreground",
                "lotteries-stories-closing-background",
                "lotteries-stories-closing-foreground",
            ]
        }, window.parent.location.origin);
    };
    Lobby.prototype.showBanner = function () {
        window.parent.postMessage({
            key: BrandingBase.SelectBrandingKey,
            value: [
                //Featured
                "featured-banner-1-lottery",
                "featured-banner-2-lottery",
            ]
        }, window.parent.location.origin);
    };
    Lobby.prototype.showCarousel = function () {
        window.parent.postMessage({
            key: BrandingBase.SelectBrandingKey,
            value: [
                //Images
                //Text
                "carousel-lotteries-lottery-footer-button",
                //Colors
                "carousel-lotteries-arrow-icon-background",
                "carousel-lotteries-arrow-icon-foreground",
                "carousel-lotteries-lottery-content-background",
                "carousel-lotteries-lottery-content-name-foreground",
                "carousel-lotteries-lottery-content-country-foreground",
                "carousel-lotteries-lottery-content-prize-foreground",
                "carousel-lotteries-lottery-content-next-draw-foreground",
                "carousel-lotteries-lottery-footer-background",
                "carousel-lotteries-lottery-footer-button-foreground",
                "carousel-lotteries-lottery-footer-button-hover-foreground",
                "carousel-lotteries-lottery-footer-button-background",
                "carousel-lotteries-lottery-footer-button-hover-background"
            ]
        }, window.parent.location.origin);
    };
    Lobby.prototype.showScratchCardsCarousel = function () {
        window.parent.postMessage({
            key: BrandingBase.SelectBrandingKey,
            value: [
                //Images
                //Text
                "scratch-cards-carousel-title",
                //Colors
                "scratch-cards-carousel-title",
                "scratch-cards-carousel-card-price-foreground",
                "scratch-cards-carousel-card-price-background",
                "scratch-cards-carousel-card-title-foreground"
            ]
        }, window.parent.location.origin);
    };
    Lobby.prototype.showLotteries = function () {
        window.parent.postMessage({
            key: BrandingBase.SelectBrandingKey,
            value: [
                //Text
                "lotteries-lotteries",
                "lotteries-sub-title",
                "lotteries-button",
                "lotteries-show-more",
                "lotteries-show-less",
                "lotteries-page-title",
                "lotteries-page-most-recent",
                "lotteries-page-all-lotteries",
                "lotteries-page-lotteries-combobox-label",
                "lotteries-page-date-combobox-label",
                //Colors
                "lotteries-title",
                "lotteries-sub-title",
                "lotteries-lottery-background",
                "lotteries-lottery-name-foreground",
                "lotteries-lottery-country-foreground",
                "lotteries-lottery-prize-foreground",
                "lotteries-lottery-next-draw-foreground",
                "lotteries-lottery-button-foreground",
                "lotteries-lottery-button-hover-foreground",
                "lotteries-lottery-button-background",
                "lotteries-lottery-button-hover-background",
                "lotteries-show-more-foreground"
            ]
        }, window.parent.location.origin);
    };
    Lobby.prototype.showInstantGameCards = function () {
        window.parent.postMessage({
            key: BrandingBase.SelectBrandingKey,
            value: [
                //Images
                //Text
                "instant-game-cards-title",
                "instant-game-cards-card-cta",
                //Colors
                "instant-game-cards-title",
                "instant-game-cards-card-details-background",
                "instant-game-cards-card-price-foreground",
                "instant-game-cards-card-title-foreground",
                "instant-game-cards-card-cta-foreground",
                "instant-game-cards-card-cta-foreground-hover",
                "instant-game-cards-card-cta-background",
                "instant-game-cards-card-cta-background-hover"
            ]
        }, window.parent.location.origin);
    };
    Lobby.prototype.showBundles = function () {
        window.parent.postMessage({
            key: BrandingBase.SelectBrandingKey,
            value: [
                //Images
                //Text
                "bundles-title",
                "bundles-no-of-lotteries",
                "bundles-play-now",
                "bundles-show-more",
                "bundles-show-less",
                "bundles-page-all-bundles-label",
                "bundles-page-title",
                "bundles-combobox-label",
                //Colors
                "bundles-title-foreground",
                "bundles-background",
                "bundles-foreground",
                "bundles-button-background",
                "bundles-button-foreground",
                "bundles-button-background-hover",
                "bundles-show-more-foreground"
            ]
        }, window.parent.location.origin);
    };
    Lobby.prototype.showInstantGames = function () {
        window.parent.postMessage({
            key: BrandingBase.SelectBrandingKey,
            value: [
                //Text
                "instant-games-title",
                "instant-games-play-now",
                //Colors
                "instant-games-title-foreground",
                "instant-games-background",
                "instant-games-button-background",
                "instant-games-button-background-hover",
                "instant-games-button-foreground",
                "instant-games-button-foreground-hover"
            ]
        }, window.parent.location.origin);
    };
    Lobby.prototype.showResults = function () {
        window.parent.postMessage({
            key: BrandingBase.SelectBrandingKey,
            value: [
                //Text
                "latest-results-title",
                "latest-results-all-results",
                "latest-results-button",
                //Colors
                "latest-results-title-foreground",
                "latest-results-border",
                "latest-results-background",
                "latest-results-all-results-foreground",
                "latest-results-name-foreground",
                "latest-results-date-foreground",
                "latest-results-country-foreground",
                "latest-results-num-background",
                "latest-results-num-border",
                "latest-results-num-foreground",
                "latest-results-num-bonus-background",
                "latest-results-num-bonus-foreground",
                "latest-results-prize-foreground",
                "latest-results-button-foreground",
                "latest-results-button-hover-foreground",
                "latest-results-button-background",
                "latest-results-button-hover-background"
            ]
        }, window.parent.location.origin);
    };
    Lobby = __decorate([
        autoinject,
        transient(),
        __metadata("design:paramtypes", [ClientLotteryClientService, Router, TokenClient, I18N, NotificationClientService,
            DialogClientService, QuickPlay, ConfigClientService, RoutingHelper, BindingSignaler])
    ], Lobby);
    return Lobby;
}(BaseLobby));
export { Lobby };
